import {useContext} from 'react';
import {useAppSelector} from '@/hooks';
import {ContextualOptionsScopeContext} from '@Components/poster-editor/components/poster-editing-side-panel/contexts/contextual-options-scope-context';

export function useSingleActivePosterItemId(pageId?: string): string | null {
  const scope = useContext(ContextualOptionsScopeContext);
  const reduxScopeItemIds = useAppSelector((state) => {
    return state.posterEditor.contextualScopeItemIds;
  });
  const singleActiveId = useAppSelector((state) => {
    const currentPageId = pageId ?? state.posterEditor.currentPageId;
    if (!currentPageId) {
      return null;
    }

    if (!state.posterEditor.activeItemIds[currentPageId]) {
      return null;
    }

    return state.posterEditor.activeItemIds[currentPageId][0];
  });

  // Inside a group/family contextual-options section the "single active item" is the section's
  // representative item — its first target. This lets every existing active-item read hook and
  // type guard work unchanged for multi-selection; only the write path is rescoped (see
  // useApplyToTargetItems). The scope is delivered by a React provider on web and by the Redux
  // contextual scope on mobile (group panels render outside the provider's subtree). Both are only
  // active under the group contextual menu, so single-selection callers elsewhere are unaffected.
  if (pageId === undefined) {
    if (scope) {
      return scope.targetItemIds[0] ?? null;
    }
    if (reduxScopeItemIds && reduxScopeItemIds.length > 0) {
      return reduxScopeItemIds[0];
    }
  }

  return singleActiveId ?? null;
}
